module.exports = __webpack_public_path__ + "img/firefox.ffa00c88.svg";